import React from "react";
import PropTypes from "prop-types";
import { Title } from "rbx";
import FollowupListItem from "../FollowupListItem";

const IncompleteFollowupsList = ({
  followupsLength,
  handleClick,
  incompleteFollowups,
  setFollowups,
  handleOpenFollowupAdd,
  showManagerReviews,
  isUsersOwnFollowups
}) => (
    <React.Fragment>
      {incompleteFollowups?.map((followup, index) => (
        <React.Fragment key={followup?.id}>
          <FollowupListItem
            followup={followup}
            followupIndex={index}
            handleClick={handleClick}
            handleOpenFollowupAdd={handleOpenFollowupAdd}
            isUsersOwnFollowups={isUsersOwnFollowups}
            showManagerReviews={showManagerReviews}
          />
        </React.Fragment>
      ))}
      {!incompleteFollowups.length  && (
        <div className="centered-title">
          <Title size={6}>
            Nice! All your follow-ups are completed
          </Title>
        </div>
      )}
    </React.Fragment>
  );

IncompleteFollowupsList.propTypes = {
  followupsLength: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  incompleteFollowups: PropTypes.array.isRequired,
  setFollowups: PropTypes.func.isRequired,
  handleOpenFollowupAdd: PropTypes.func.isRequired,
  showManagerReviews: PropTypes.bool,
  isUsersOwnFollowups: PropTypes.bool
};

IncompleteFollowupsList.defaultProps = {
  showManagerReviews: false,
  isUsersOwnFollowups: false
};

export default IncompleteFollowupsList; 